import moment from 'moment';
import {getInState} from './composeReducer.js';

export function createLogger(log_options, store) {
    if (!log_options) {
        return {
            serverLog : function(){},
            serverError : function(){}
        }
    }

    function serverLog() {
        let log = '';
        let log_items = [];
        let app_id = getInState(store.getState, 'app.id');
        let isbn = getInState(store.getState, 'model.isbn13', '');
        let chapter_id = getInState(store.getState, 'problem.chapter.id', '');
        let problem_id = getInState(store.getState, 'problem.id', '');

        let app_string = app_id ? ` ID: ${app_id} | ` : '';
        let timestamp = moment().format(log_options.date_format);
        let metadata_string = `${isbn}|${chapter_id}|${problem_id}`;
        try {
            for (var i = 0; i < arguments.length; i++) {
                let str = arguments[i];
                try {
                    if (typeof str == 'object') {
                        str = JSON.stringify(str);
                    }
                } catch (e) {
                    str = '[Object object]';
                }
                log_items.push(str);
            }
            log = log_items.join(' ');
        } catch (e) {
            log = 'LOG ERROR: ' + e;
        }
        console.log(`${app_string}${timestamp} ${metadata_string}: ${log}`);
    }

    function serverError() {
        var args = Array.prototype.slice.call(arguments, 0);
        args.unshift('ERROR: ');
        serverLog.apply(args);
    }

    return {
        serverLog,
        serverError
    }
}




// WEBPACK FOOTER //
// ./src/helpers/server.logger.js